module.exports = __webpack_public_path__ + "img/HZ-A0505.87c2cb19.jpg";